import React, { FC } from 'react';
import { Box, Text } from '@bechtel/gds';
interface CommodityInfoProps {
  commodityId: string;
  commodityTag: string;
  locationDescription?: string;
}
export const CommodityInfo: FC<CommodityInfoProps> = ({ commodityId, commodityTag, locationDescription }) => {
  return (
    <Box style={{ maxWidth: '284px' }} flexDirection={{ sm: 'column' }} key={commodityId}>
      <Text size="400" weight="600">
        {commodityTag}
      </Text>
      <Box mt={{ sm: '400' }}>
        <Text size="400" style={{ whiteSpace: 'pre-wrap' }}>
          {locationDescription}
        </Text>
      </Box>
    </Box>
  );
};
